import React, { FC } from 'react'

import { Trans } from 'react-i18next'

import { useFindNearestByImgWidth } from '@/hooks/useFindNearestByImgWidth'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'
import { EventInformationProps } from '@/types/componentsPropsTypes'

import {
  InformationChannelLogo,
  InformationDetails,
  InformationTitle,
  InformationWrapper,
  StyledImage,
  InformationText,
} from './styles'

export const EventInformation: FC<EventInformationProps> = ({
  sources,
  eventInformation,
  qrImage,
}) => {
  const { t } = useCommonTranslation()
  const iconSrc = useFindNearestByImgWidth(sources, 150, {
    prioritizeSvg: true,
  })?.url
  const imageSrc = qrImage || iconSrc
  const showLogo = !!imageSrc

  return (
    <InformationWrapper>
      <InformationTitle>{t('information')}</InformationTitle>
      <InformationDetails $withLogo={showLogo}>
        <InformationText>
          <Trans defaults={eventInformation} />
        </InformationText>
        {showLogo && (
          <InformationChannelLogo>
            <StyledImage src={imageSrc} />
          </InformationChannelLogo>
        )}
      </InformationDetails>
    </InformationWrapper>
  )
}
